import React from "react";
import ExistingOrderPage from "../components/ExistingOrderPage";

export default function OrdersCopyPage() {
  return <ExistingOrderPage mode="copy" />;
}
